import { useMemo } from "react";
import { useLocation } from "react-router-dom";

const useLocator = () => {
  const { pathname } = useLocation();
  const [isBank, isSelfPartner, isPartner] = useMemo(() => [
    pathname.startsWith("/banks"),
    pathname.startsWith("/selfPartner"),
    pathname.startsWith("/partners")
  ], [pathname]);

  const path = isBank ? "banks" : isSelfPartner ? "selfPartner" : isPartner ? "partners" : pathname.split("/")[1];

  return { isBank, isSelfPartner, isPartner, path };
}
export default useLocator;
